module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/ebsProfile-abdda1e5f7dc5e83495bdfd3d75006fe.png";